module.exports = __webpack_public_path__ + "img/img46.7ba0c12e.jpg";